import React, { Component } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from "reactstrap";

export default class HeaderDropdownComponentForMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdownOpen: false
    };
  }

  toggleDropDown = () => {
    this.setState(state => ({
      isDropdownOpen: !state.isDropdownOpen
    }));
  };

  render() {
    return (
      <div className="ml-2 d-flex">
        <div
          role="presentation"
          className="contentHeader__searchContainer"
          onClick={this.props.showSearchBoxForMobileView}
        >
          <i className=" bx bx-search bx-sm " />
        </div>
        <Dropdown
          className="d-inline-block"
          isOpen={this.state.isDropdownOpen}
          toggle={this.toggleDropDown}
        >
          <DropdownToggle className="iconButton" caret>
            <i className="ml-1 bx bx-dots-vertical-rounded" />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem>
              <span
                role="presentation"
                onClick={() => {
                  this.props.handleRefresh();
                }}
              >
                Refresh
              </span>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem>
              <span
                role="presentation"
                onClick={() => {
                  this.props.handleView("list");
                }}
              >
                List View
              </span>
            </DropdownItem>
            <DropdownItem>
              <span
                role="presentation"
                onClick={() => {
                  this.props.handleView("grid");
                }}
              >
                Grid View
              </span>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        {this.props.refreshing && (
          <div>
            <div
              id="notification_toast-flash"
              className="notification_toast info animated fadeInUp"
            >
              <p>
                Refreshing <i className="fa fa-spinner fa-spin" />
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }
}
